// CountDev.jsx - Enhanced development projects counter
import React, { useEffect } from 'react';
import { Card, Statistic, Progress, Space, Tag, Tooltip, Typography } from 'antd';
import { CodeOutlined, TrophyOutlined, ClockCircleOutlined } from '@ant-design/icons';
import { getDevProjects } from '../../features/projects/devprojectSlice';
import { useDispatch, useSelector } from 'react-redux';

const { Text } = Typography;

const CountDev = () => {
  const { devprojects, loading } = useSelector((state) => state.devprojects);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getDevProjects());
  }, [dispatch]);

  // Calculate stats
  const completedProjects = devprojects?.filter(p => p.status === 'completed')?.length || 0;
  const inProgressProjects = devprojects?.filter(p => p.status === 'in-progress')?.length || 0;
  const totalProjects = devprojects?.length || 0;
  const completionRate = totalProjects > 0 ? Math.round((completedProjects / totalProjects) * 100) : 0;

  return (
    <Card 
      className="shadow-medium border border-border-light rounded-xl bg-white hover:shadow-hard transition-all duration-300 h-full"
      bodyStyle={{ padding: '24px' }}
      loading={loading}
    >
      <div className="text-center">
        <div className="flex justify-center mb-4">
          <div className="w-16 h-16 bg-gradient-to-br from-accent-blue to-blue-600 rounded-full flex items-center justify-center">
            <CodeOutlined className="text-2xl text-white" />
          </div>
        </div>
        
        <Statistic
          title={
            <span className="text-text-secondary font-medium text-sm uppercase tracking-wide">
              Development Projects
            </span>
          }
          value={totalProjects}
          valueStyle={{
            color: '#19868d',
            fontSize: '3rem',
            fontWeight: 'bold',
            fontFamily: 'Montserrat'
          }}
        />

        <Space direction="vertical" size="small" className="w-full mt-4">
          <div className="flex justify-between items-center">
            <Text className="text-text-secondary text-sm">Completion Rate</Text>
            <Text className="text-accent-blue font-semibold">{completionRate}%</Text>
          </div>
          <Progress 
            percent={completionRate} 
            strokeColor="#19868d"
            trailColor="#f1f5f9"
            strokeWidth={8}
            showInfo={false}
          />
          
          <div className="flex justify-between mt-3">
            <Tooltip title="Completed Projects">
              <Tag color="green" className="flex items-center space-x-1">
                <TrophyOutlined />
                <span>{completedProjects}</span>
              </Tag>
            </Tooltip>
            <Tooltip title="In Progress">
              <Tag color="orange" className="flex items-center space-x-1">
                <ClockCircleOutlined />
                <span>{inProgressProjects}</span>
              </Tag>
            </Tooltip>
          </div>
        </Space>
      </div>
    </Card>
  );
};

export default CountDev;